import { _Inbox, _NoteImp, _ProcedureImp } from "../../../core/services/dataBean/EntityCatalog";
import { RenderJavaForm } from "../RenderJavaForm";
import { RenderForm } from "../../theme/Component/RenderForm";
import { DynamicFormHandler } from "../DinamicHandlerForm";
import { PrintJson } from "../../theme/Component/PrintJson";
import { RenderDocumentTRD } from "./RenderDocumentTRD";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    action: any;
    procedure: any;
    requestListAction: Function;
}
export const RenderInbox = ({ action, procedure, requestListAction }: Props) => {

    const { instance } = useDataBean(_Inbox)

    const updateForm = (map: any) => {
        console.log(map);
        instance.responseProcedureAction(action.IDAction, "", true, map, false).then(
            (resp) => {
                if (requestListAction) {
                    requestListAction();

                }

            }
        ).catch(err => {

            toast.error("No se pudo enviar la respuesta")
        })

    }

    const renderSwitch = (item: any) => {
        const isNumeric = !isNaN(Number(item.FormCode));
        if (item.FormCode == 111) {
            return (
                <RenderJavaForm action={action} exportMap={updateForm} />
            )
        }

        if (item.FormCode == 112) {
            return (
                <RenderForm idFormType={112} handleUpdate={(e: any) => updateForm(e)} />
            )
        }

        if (isNumeric) {
            return (
                <RenderForm
                    idFormType={item.FormCode}
                    handleUpdate={(e: any) => updateForm(e)}
                />
            );
        } else {
            return (
                <DynamicFormHandler
                    procedure={procedure}
                    formCode={item.FormCode}
                    procedureAction={item}
                    updateForm={updateForm}
                />
            );
        }
    };

    const renderTypeAction = (action: any) => {
        console.log(action);
        switch (action.DocumentType) {
            case 3:
                return <RenderJavaForm action={action} exportMap={updateForm} />
            case 2:
                return <RenderDocumentTRD action={action} exportMap={updateForm} />
            case 6:
                return renderSwitch(action);
            default:
                return <PrintJson json={action} />
        }

    }

    return (
        <div className="row">
            {/* <PrintJson json={action} /> */}
            <div className="col-md-12">
                {renderTypeAction(action)}
            </div>
        </div >
    )
}